import React from "react";
import { useNavigate } from "react-router-dom";
import { BillingContextProvider, CDCheckout } from "component-library";
import { logCustomEvent as brazeCustomEvent } from "@braze/web-sdk";
import { CheckoutAccessTypes } from "component-library/src/components/Organisms/Billing/types";
import { BASE_PATH } from "config/common";
import { useGetBillingContextDefaultProps } from "../hooks/useGetBillingContextDefaultProps";
import { CheckoutBrazeEventTypes } from "pages/CheckoutPageWrapper/types";

export default function CDWrapper({
  brazeSubscriptionPurchaseType,
}: CheckoutBrazeEventTypes) {
  const navigate = useNavigate();
  const defaultProps = useGetBillingContextDefaultProps(
    CheckoutAccessTypes.RenewalReactivation
  );

  const postCheckoutCallback = (_: any, trackingData: Record<string, any>) => {
    brazeCustomEvent(brazeSubscriptionPurchaseType, {
      memberType: trackingData.memberType,
      paymentPeriod: trackingData.paymentPeriod,
      revenue: trackingData.paymentValue,
    });
  };

  return (
    <BillingContextProvider
      {...defaultProps}
      postCheckoutCallback={postCheckoutCallback}
      goBack={() => navigate(BASE_PATH)}
    >
      <CDCheckout />
    </BillingContextProvider>
  );
}
